// FORM
import EquipmentWrapper from './EquipmentWrapper/form/equipment'
import PointWrapper from './PointWrapper/form/point'
import SupplierWrapper from './SupplierWrapper/form/supplier'
import ServiceWrapper from './ServiceWrapper/form/service'
import LaundryWrapper from './LaundryWrapper/form/laundry'
import LaundryOperationWrapper from './LaundryOperationWrapper/form/laundryOperation'
import InspectWrapper from './MaintenanceInspectWrapper/form/inspect'
import LaundryConfigHoursWrapper from './LaundryConfigHoursWrapper/form/laundryConfigHours'
import FormConfigDay from './LaundryConfigDaysWrapper/form/config'
// TABLAS
import {TableAppLaundryWrapper} from './AppLaundryWrapper/table/laundry'
import {TableDetailLaundryWrapper} from './AppLaundryWrapper/table/detailLaundry'
import {TableCheckInWrapper} from './CheckInWrapper/table/CheckIn'
import {TableCheckOutWrapper} from './CheckOutWrapper/table/CheckOut'
import {TableEquipmentWrapper} from './EquipmentWrapper/table/equipment'
import {TableLaundryWrapper} from './LaundryWrapper/table/laundry'
import {TableLaundryOutWrapper} from './LaundryOutWrapper/table/laundryOut'
import {TableLaundryReceptionWrapper} from './LaundryReceptionWrapper/table/laundryReception'
import {TableLaundryTimeWrapper} from './LaundryTimeWrapper/table/laundryTime'
import {TableLaundryFrecuencyWrapper} from './LaundryFrecuencyWrapper/table/laundryFrecuency'
import {TableLaundryBillingWrapper} from './LaundryBillingWrapper/table/laundryBilling'
import {TableLaundryBilling2Wrapper} from './LaundryBillingWrapper/table/laundryBilling2'
import {TableLaundryGenerateBillingWrapper} from './LaundryGenerateBillingWrapper/table/laundryGenerateBilling'
import {TableLaundryOperationWrapper} from './LaundryOperationWrapper/table/laundryOperation'
import {TablePointWrapper} from './PointWrapper/table/point'
import {TableSupplierWrapper} from './SupplierWrapper/table/supplier'
import {TableServiceWrapper} from './ServiceWrapper/table/service'
import {TableInspectWrapper} from './MaintenanceInspectWrapper/table/inspect'
import {TableLaundryBatchWrapper} from './LaundryBatch/table'
import {TableLaundryGenerateBatchWrapper} from './LaundryGenerateBatch/table/laundry'
import {TableConfigDayWrapper} from './LaundryConfigDaysWrapper/table/config'
import {TableReportValoration} from './ReportValorationWrapper/Tables/TableValuation'
// TABS
import DetailSuppliersPanel from './SupplierWrapper/Tabs/DetailSuppliersPanel'
import LaundryTab from './LaundryWrapper/Tabs/laundry'
import AppLaundryTab from './AppLaundryWrapper/Tabs/laundry'
import LaundryOperationTab from './LaundryOperationWrapper/Tabs/laundryOperation'
import InspectTab from './MaintenanceInspectWrapper/Tabs/inspect'
import PointTab from './PointWrapper/Tabs/furniture'
import LaundryBillingReportTab from './LaundryBillingWrapper/Tabs/laundryBilling'
import {InspectionPageWrapper} from './ReportInspectionWrapper/InspectionPageWrapper'
import LaundryBatchTab from './LaundryBatch/Tabs/laundry'
import {TableLaundryConfigHoursWrapper} from './LaundryConfigHoursWrapper/table/laundryConfigHours'
import {HeaderDeliveryClothesPanel} from './DeliveryClothes/panels/HeaderDeliveryClothesPanel'
import {TableManagementSequentialWrapper} from './ManagementSequentialWrapper/table/managementSequential'

import FormManagementSequential from './ManagementSequentialWrapper/form/managementSequential'

export const ListComponentsCentral = {
  'form-equipment': <EquipmentWrapper />,
  'form-inspect': <InspectWrapper />,
  'form-laundry': <LaundryWrapper />,
  'form-operation': <LaundryOperationWrapper />,
  'form-point': <PointWrapper />,
  'form-supplier': <SupplierWrapper />,
  'form-service': <ServiceWrapper />,
  'form-configuration-hours': <LaundryConfigHoursWrapper />,
  'form-configuration-days': <FormConfigDay />,
  'form-management-sequential': <FormManagementSequential />,
  'table-checkIn': <TableCheckInWrapper />,
  'header-laundry-app': <TableDetailLaundryWrapper />,
  'table-batch': <TableLaundryBatchWrapper />,
  'table-generate-batch': <TableLaundryGenerateBatchWrapper />,
  'table-laundry-app': <TableAppLaundryWrapper />,
  'table-checkOut': <TableCheckOutWrapper />,
  'table-equipment': <TableEquipmentWrapper />,
  'table-inspect': <TableInspectWrapper />,
  'table-laundry': <TableLaundryWrapper />,
  'table-out': <TableLaundryOutWrapper />,
  'table-operation': <TableLaundryOperationWrapper />,
  'table-point': <TablePointWrapper />,
  'table-reception': <TableLaundryReceptionWrapper />,
  'table-report-laundry-frecuency': <TableLaundryFrecuencyWrapper />,
  'table-report-laundry-time': <TableLaundryTimeWrapper />,
  'table-report-laundry-billing': <TableLaundryBillingWrapper />,
  'table-report-billing-laundry': <TableLaundryBilling2Wrapper />,
  'table-generate-report-laundry-billing': <TableLaundryGenerateBillingWrapper />,
  'table-supplier': <TableSupplierWrapper />,
  'table-service': <TableServiceWrapper />,
  'tab-inspect': <InspectTab />,
  'tab-laundry': <LaundryTab />,
  'tab-laundry-app': <AppLaundryTab />,
  'tab-laundry-batch': <LaundryBatchTab />,
  'tab-operation': <LaundryOperationTab />,
  'tab-point': <PointTab />,
  'tab-supplier': <DetailSuppliersPanel />,
  'tab-laundry-billing': <LaundryBillingReportTab />,
  'table-report-inspection-observation': <InspectionPageWrapper />,
  'table-configuration-hours': <TableLaundryConfigHoursWrapper />,
  'table-configuration-days-laundry': <TableConfigDayWrapper />,
  'header-delivery-clothes-bed': <HeaderDeliveryClothesPanel />,
  'table-report-valoration': <TableReportValoration />,
  'table-management-sequential': <TableManagementSequentialWrapper />,
} as any

export const renderPanelContent = (key: string | undefined) => {
  let component = <></>
  if (key) {
    component = ListComponentsCentral[key]
  }
  return component
}
